import { motion } from "framer-motion";
import { WHATSAPP_URL } from "../App";
import { CalendarDays } from "lucide-react";

const t = {
  es: {
    label: "¿Listo para escapar?",
    title: "¿Listo para",
    titleAccent: "la Costa?",
    subtitle:
      "Asegura tus fechas ahora y empieza a planificar tu escape tropical perfecto en Berlisa del Pacífico.",
    whatsapp: "Contactar por WhatsApp",
    availability: "Consultar Disponibilidad",
  },
  en: {
    label: "Ready to escape?",
    title: "Ready for",
    titleAccent: "the Coast?",
    subtitle:
      "Secure your dates now and start planning your perfect tropical escape at Berlisa del Pacífico.",
    whatsapp: "Contact via WhatsApp",
    availability: "Check Availability",
  },
};

export default function CTABanner({ lang }) {
  const tr = t[lang];

  return (
    <section
      id="cta"
      data-testid="cta-banner-section"
      className="py-20 px-6"
    >
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 25 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="relative rounded-3xl overflow-hidden bg-[#1F3A5E] px-8 py-20 text-center"
        >
          {/* Decorative circles */}
          <div className="absolute top-0 left-0 w-64 h-64 rounded-full bg-white/5 -translate-x-1/2 -translate-y-1/2" />
          <div className="absolute bottom-0 right-0 w-96 h-96 rounded-full bg-white/5 translate-x-1/3 translate-y-1/3" />

          <div className="relative z-10">
            <p className="font-montserrat text-[#D4B895] text-sm font-semibold tracking-widest uppercase mb-4">
              {tr.label}
            </p>
            <h2 className="font-montserrat font-extrabold text-white text-4xl md:text-6xl leading-tight mb-5">
              {tr.title}{" "}
              <span className="text-[#D4B895]">{tr.titleAccent}</span>
            </h2>
            <p className="font-dm-sans text-white/70 text-base md:text-lg max-w-xl mx-auto mb-10">
              {tr.subtitle}
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="cta-whatsapp-btn"
                className="inline-flex items-center gap-2.5 px-8 py-4 bg-white text-[#1F3A5E] rounded-full font-montserrat font-bold text-sm hover:-translate-y-0.5 hover:shadow-xl transition-transform duration-200"
              >
                <svg className="w-5 h-5" fill="#25D366" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                </svg>
                {tr.whatsapp}
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
